import { render, staticRenderFns } from "./UnidadeMedidaVinculoModal.vue?vue&type=template&id=8a2de9b4&scoped=true"
import script from "./UnidadeMedidaVinculoModal.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaVinculoModal.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedidaVinculoModal.vue?vue&type=style&index=0&id=8a2de9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2de9b4",
  null
  
)

export default component.exports